import { RxCrossCircled } from "react-icons/rx";
import logo from '../../assets/Deli_Logo.svg'
import React, { useState, useEffect } from "react";
import NotesCard from '../NotesCard';

const PopUpClientNotes = ({answerHash, notes, setNotesPopup, updateNotes, userName, picture, deleteNote, isAuthenticated}) => {
    const [clientNotes,setClientNotes] = useState('');
    const [notesList, setNotesList] = useState(notes);

    useEffect(() => {
        setNotesList(notes)
      },[notes]);

    const handleAddNote = () =>{
        updateNotes(null, clientNotes, answerHash);
        setClientNotes('');
    }

    const handleEditNoteSubmit = (noteid,text) => {
        updateNotes(noteid, text, answerHash);
    }

    const handleDeleteNote = (noteid) =>{
        deleteNote(noteid)
    }

    return (
        <div className='flex z-30 justify-center items-center w-full top-0 bottom-0 m-auto absolute left-0 right-0'>
            <div className={`notespopup flex flex-col px-4 py-4 lg:px-10 lg:py-10 bg-white max-h-[80vh] max-h-[80dvh] overflow-y-auto rounded-2xl w-[90%] md:w-[50%] xl:w-[30%]`}>
                <div id='header' className='flex justify-end items-center'>
                    <div onClick={() => setNotesPopup(false)} className='flex justify-end cursor-pointer'>
                        <RxCrossCircled className='text-gray-500' size={22} />
                    </div>
                </div>
                <div className='flex items-center flex-col mb-4'>
                    <div>
                        <img width={70} src={logo} alt="" className="mb-6"/>
                    </div>
                    <h3 className="text-black font-semibold text-3xl text-center w-70">
                        Put a note here
                    </h3>
                    <p className="text-[14px] lg:max-w-[70%] md:max-w-[75%] text-center">
                        You can put your note here
                    </p>
                </div>
                {
                    
                    notesList && notesList.length > 0 ? (
                        <div>
                        {notesList.map((note, index) => (
                            <NotesCard 
                              key={index} 
                              note={note}
                              picture = {picture}
                              userName = {userName}
                              rows = {2}
                              updateNote={handleEditNoteSubmit}
                              deleteNote={handleDeleteNote}
                              isAuthenticated = {isAuthenticated}
                            />
                        ))}
                          </div>
                        ) : (
                        <></>
                    )
                }
                <div>
                    <textarea
                    onChange={(e) => setClientNotes(e.target.value)}
                    className="w-full py-3 mt-2 px-4 rounded-2xl border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                    placeholder="Enter your notes please"
                    rows={4}
                    value= {clientNotes}
                    />
                    <div className='flex items-center lg:gap-16 mt-2'>
                        <button
                            onClick={handleAddNote}
                            type="button"
                            className='text-md py-4 rounded-full w-full flex justify-center items-center bg-[#0062FF] text-white px-5 transition-transform duration-300 hover:scale-105'
                        >
                            Add Note
                        </button>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default PopUpClientNotes;
